import React from 'react';

interface ButtonProps {
  label?: string;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  loading = false,
  disabled = false,
  className = "is-warning",
}) => {
  const buttonClass = `button ${className}`;

  if (loading) {
    return (
      <a className={buttonClass} disabled>
        <span className="icon">
          <i className="fa fa-spinner fa-spin"></i>
        </span>
      </a>
    );
  }

  return (
    <a className={buttonClass} onClick={onClick} role="button" tabIndex={0}>
      {label}
    </a>
  );
};

export default Button;
